export default __webpack_public_path__ + "static/corona-e02ba96af9d37e86788e4b442649ea4d.png";